'use client';

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { EMPTY_POSTHOG_FEATURE_FLAGS } from 'commons/constants';

import PostHogFeatureFlagsContext from './PostHogFeatureFlagsContext';

const PostHogFeatureFlagsProvider = ({
  value = EMPTY_POSTHOG_FEATURE_FLAGS,
  distinctId = null,
  children,
}) => {
  const contextValue = useMemo(() => ({ featureFlags: value, distinctId }), [
    distinctId,
    value,
  ]);

  return (
    <PostHogFeatureFlagsContext.Provider value={contextValue}>
      {children}
    </PostHogFeatureFlagsContext.Provider>
  );
};

PostHogFeatureFlagsProvider.propTypes = {
  value: PropTypes.object,
  distinctId: PropTypes.string,
  children: PropTypes.node,
};

export default PostHogFeatureFlagsProvider;
